module.exports = {
  endpoint: 'https://api.pokemontcg.io/v1'
}
